import React from 'react';
import { AlertTriangle } from 'lucide-react';

// Casilla siempre visible: solo clientes con algún CVU activo de un banco sponsor anterior.
export const PadronFiltroSponsorAnterior = ({ checked, onChange }) => (
  <label
    className={`mt-3 inline-flex items-center gap-2 px-3 py-1.5 rounded-md border text-sm cursor-pointer transition-colors ${
      checked ? 'bg-amber-50 border-amber-300 text-amber-900' : 'bg-white border-slate-200 text-slate-600 hover:bg-slate-50'
    }`}
    data-testid="filtro-sponsor-anterior-label"
  >
    <input
      type="checkbox"
      className="w-4 h-4 rounded accent-amber-600"
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      data-testid="filtro-sponsor-anterior"
    />
    <AlertTriangle size={14} className={checked ? 'text-amber-600' : 'text-slate-400'} />
    Solo clientes con CVU activos de bancos anteriores
  </label>
);
